import { ErrorState } from "@/app/components/legacy-components";
import {
  CardsGrid,
  PastSessionCard,
  SessionsEmptyState,
} from "@/features/coaching/components";
import {
  useAdminSessions,
  useSessionCategory,
  useSessionStatus,
} from "@/features/coaching/hooks";
import { usePagination } from "@/shared/hooks";
import { Card, DetailCardSkeleton, Pagination } from "@/shared/ui";

export const AdminPastSessions = () => {
  const { category } = useSessionCategory();
  const { status } = useSessionStatus();

  const {
    page,
    pageSize,
    actions: { changePage },
  } = usePagination();

  const { data, isLoading, isSuccess, isError } = useAdminSessions({
    filter: { category, status },
    // TODO: BE - page size not working
    pagination: { page, pageSize },
  });
  const sessions = data?.data ?? [];
  const pagination = data?.pagination;

  return (
    <Card.Root className="h-full gap-4">
      {isLoading && (
        <CardsGrid>
          {Array.from({ length: 4 }).map((_, index) => (
            <DetailCardSkeleton key={`detail-card-skeleton-${index}`} />
          ))}
        </CardsGrid>
      )}

      {Boolean(isSuccess && sessions.length) && (
        <CardsGrid>
          {sessions.map((session) => (
            <PastSessionCard admin key={session.id} session={session} />
          ))}
        </CardsGrid>
      )}

      {isSuccess && !sessions.length && <SessionsEmptyState />}

      {isError && (
        <ErrorState className="justify-self-center border-transparent" />
      )}

      {pagination && pagination.totalPages > 1 && (
        <div className="flex justify-center border-t border-neutral-400 pt-4 md:justify-end">
          <Pagination {...pagination} onPageChange={changePage} />
        </div>
      )}
    </Card.Root>
  );
};
